import { render } from "./AnnouncementSection.vue?vue&type=template&id=16ca021a&scoped=true"
import script from "./AnnouncementSection.vue?vue&type=script&lang=js"
export * from "./AnnouncementSection.vue?vue&type=script&lang=js"

import "./AnnouncementSection.vue?vue&type=style&index=0&id=16ca021a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ca021a"]])

export default __exports__